import styles from '../../styles/pages/NotFound.module.css';
import { DeviceSpecificLayout } from 'components/Layout/DeviceSpecificLayout';
import { BrandPlaceholder } from 'components/BrandPlaceholder/BrandPlaceholder';

export const NotFound = () => {
  const getContent = () => {
    return (
      <div className={styles.wrapper}>
        <BrandPlaceholder messageKey="page_not_found_label" />
      </div>
    );
  };

  return <DeviceSpecificLayout>{getContent()}</DeviceSpecificLayout>;
};
